/**
 * 字符串哈希压缩
 */
export const hashString = (str: string): string => {
  let hash = 0;
  if (str.length === 0) return hash.toString(36);
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // 转换为32位整数
  }
  return Math.abs(hash).toString(36);
};

export const getWeightedCharLength = (str?: string): number => {
  if (!str) {
    return 0
  }
  return [...str].reduce((acc, char) => {
    const code = char.codePointAt(0)!;
    const isCJKOrJapanese =
      (code >= 0x4e00 && code <= 0x9fff) ||
      (code >= 0x3400 && code <= 0x4dbf) ||
      (code >= 0x3040 && code <= 0x309f) ||
      (code >= 0x30a0 && code <= 0x30ff) ||
      (code >= 0xf900 && code <= 0xfaff);

    return acc + (isCJKOrJapanese ? 2 : 1);
  }, 0);
};

export const truncateByWeightedLength = (
  value: string,
  maxLength: number,
  countLength: (value: string) => number = getWeightedCharLength
): string => {
  let result = '';

  for (const char of value) {
    const nextValue = result + char;

    if (countLength(nextValue) > maxLength) {
      return result;
    }

    result = nextValue;
  }

  return result;
};

export const isWeightedLengthAtMost = (
  value: string | undefined,
  maxLength: number,
  countLength: (value: string) => number = getWeightedCharLength
): boolean => {
  return countLength(value || '') <= maxLength;
};
